import React, { useCallback, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import UnclaimedWorkDetail from './UnclaimedWorkDetail'
import '../../../styles/hmiReskin.css'
import '../DashboardV2/dashboardV2.css'
import './unclaimedWork.css'

function UnclaimedWorkItemPage(props) {
  const { url, user, match } = props
  const itemId = match?.params?.id
  const [item, setItem] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  const fetchItem = useCallback(async () => {
    if (!url || !itemId) return
    setLoading(true)
    setError('')
    try {
      const res = await axios.get(`${url}/api/hmi/unclaimed-work/${itemId}`)
      if (res.data?.success) setItem(res.data.data)
      else setError('Failed to load work item')
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to load work item')
    }
    setLoading(false)
  }, [url, itemId])

  useEffect(() => {
    fetchItem()
  }, [fetchItem])

  const handleUpdate = useCallback((updatedItem) => {
    if (updatedItem?._id) setItem(updatedItem)
    else fetchItem()
  }, [fetchItem])

  return (
    <div className="uw-work-screen-page">
      <div className="uw-work-item-page">
        {loading && !item && (
          <div className="uw-work-item-shell">
            <div style={{ padding: 40, color: 'var(--ink-3)', textAlign: 'center' }}>Loading...</div>
          </div>
        )}
        {error && !item && (
          <div className="uw-work-item-shell">
            <div style={{ padding: 40, color: 'var(--risk)', textAlign: 'center' }}>{error}</div>
          </div>
        )}
        {item && (
          <div className="uw-work-item-shell">
            <UnclaimedWorkDetail
              item={item}
              url={url}
              currentUser={user}
              currentUserId={user?._id}
              onUpdate={handleUpdate}
              workMode
            />
          </div>
        )}
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  url: state.url,
  user: state.user,
  authenticated: state.authenticated,
})

export default connect(mapStateToProps)(UnclaimedWorkItemPage)
